package com.smashvoter

import androidx.compose.runtime.Composable
import com.smashvoter.api.ApiClient
import com.smashvoter.screens.AdminScreen
import com.smashvoter.screens.LoginScreen
import com.smashvoter.screens.OnboardingScreen
import com.smashvoter.screens.PairScreen
import com.smashvoter.screens.TrustScreen
import com.smashvoter.state.AppState
import com.smashvoter.state.Screen
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable

fun main() {
    // Public pages bypass auth entirely.
    // Check both the hash (#trust) and the pathname (/trust) so the page works
    // regardless of whether the hosting platform rewrites the path correctly.
    val hash = window.location.hash.trimStart('#').trimStart('/')
    val path = window.location.pathname.trim('/')
    if (hash == "trust" || path == "trust") {
        AppState.currentScreen = Screen.TRUST
    } else {
        AppState.loadFromStorage()
    }

    val apiClient = ApiClient()

    renderComposable(rootElementId = "root") {
        App(apiClient)
    }
}

@Composable
fun App(apiClient: ApiClient) {
    val sessionId = AppState.sessionId

    when (AppState.currentScreen) {
        Screen.LOGIN -> LoginScreen(apiClient)
        Screen.ONBOARDING -> {
            if (sessionId != null) OnboardingScreen(apiClient) else LoginScreen(apiClient)
        }
        Screen.PAIR -> {
            if (sessionId != null) PairScreen(apiClient) else LoginScreen(apiClient)
        }
        Screen.ADMIN -> {
            if (sessionId != null) AdminScreen(apiClient) else LoginScreen(apiClient)
        }
        Screen.TRUST -> TrustScreen(apiClient)
    }
}
